import { useState } from "react";
import { useField } from "formik";
import { useGesamtBerechnung } from "./useGesamtBerechnung";
import { useMaterialPreisUndMenge } from "./useMaterialPreisUndMenge";

interface UseMaterialtransportProps {
  index: number;
  materialTransportIndex: number;
  fahrzeugId: string;
  materialtransport: any;
}

export const useMaterialtransport = ({
  index,
  materialTransportIndex,
  fahrzeugId,
  materialtransport,
}: UseMaterialtransportProps) => {
  const [isKosten, setIsKosten] = useState(
    materialtransport.buchungsArt === "Kosten"
  );
  const [ladestelleField] = useField(
    `fuhrparkeintraege.${index}.materialtransport.${materialTransportIndex}.quelleBaustelle`
  );
  const [baustelleField] = useField(
    `fuhrparkeintraege.${index}.materialtransport.${materialTransportIndex}.zielBaustelle`
  );
  const [abfallartField] = useField(
    `fuhrparkeintraege.${index}.materialtransport.${materialTransportIndex}.abfallart`
  );
  const [lfsnrField] = useField(
    `fuhrparkeintraege.${index}.materialtransport.${materialTransportIndex}.lieferscheinNummer`
  );
  const [bemerkungField] = useField(
    `fuhrparkeintraege.${index}.materialtransport.${materialTransportIndex}.bemerkung`
  );
  const [buchungsArtField] = useField(
    `fuhrparkeintraege.${index}.materialtransport.${materialTransportIndex}.buchungsArt`
  );

  const [fahrzeugField] = useField(`fuhrparkeintraege.${index}.fahrzeug`);

  const { einheitField } = useMaterialPreisUndMenge({
    index,
    materialTransportIndex,
    fahrzeugId,
    materialtransportId: materialtransport.id,
    type: "materialtransport",
  });

  const { mengeField, preisField, fuhrenField } = useGesamtBerechnung({
    index,
    materialTransportIndex,
    type: "materialtransport",
  });

  return {
    isKosten,
    setIsKosten,
    ladestelleField,
    baustelleField,
    abfallartField,
    lfsnrField,
    bemerkungField,
    buchungsArtField,
    einheitField,
    mengeField,
    preisField,
    fuhrenField,
    fahrzeugField,
  };
};
